import React from 'react';
import { Post } from '../../lib/directus';
import BlogCard from './BlogCard';

interface BlogListProps {
  posts: Post[];
  loading?: boolean;
  error?: string | null;
}

const BlogList: React.FC<BlogListProps> = ({ posts, loading, error }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-gray-200 animate-pulse rounded-lg h-80" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-red-600 text-lg">{error}</p>
        <p className="text-gray-600 mt-2">Попробуйте обновить страницу</p>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600 text-lg">Посты не найдены</p>
        <p className="text-gray-500 mt-2">Попробуйте изменить параметры фильтрации</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {posts.map((post) => (
        <BlogCard key={post.id} post={post} />
      ))}
    </div>
  );
};

export default BlogList;